import { FC } from 'react';
import { generateProductTitle } from '../product/helper/generate-product-title';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { ProductPageQuery } from '../../@types/codegen/graphql';
import { generateProductOfferSchema } from '../../schema.org/price.offer.schema';

const { publicRuntimeConfig } = getConfig();

type ProductDetailSchemaProps = {
  productBundle: ProductPageQuery['productBundle']
}

export const ProductDetailSchema: FC<ProductDetailSchemaProps> = ({ productBundle }) => {
  // Do not add any structured json data if we have no prices, as Google does not like that.
  if (0 === (productBundle?.bundle?.prices.length ?? 0)) {
    return <></>;
  }

  const router = useRouter();

  const offers = generateProductOfferSchema(productBundle?.bundle?.prices ?? []);
  const structuredJSON = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    'identifier': `${productBundle?.bundle?.type.id}-${productBundle?.bundle?.selectedRentalStation?.id ?? ''}`,
    'description': productBundle?.bundle?.type.text,
    'name': productBundle?.bundle ? generateProductTitle(productBundle?.bundle.type, productBundle.bundle.properties) : '',
    'category': productBundle?.bundle?.type.mainCategory?.title ?? '',
    'model': productBundle?.bundle?.type.title ?? '',
    'manufacturer': productBundle?.bundle?.type.manufacturer?.title ?? '',
    'image': productBundle?.bundle?.type.images?.[0].url,
    'url': `${publicRuntimeConfig.appBaseUrl}${router.asPath}`,
    'brand': {
      '@type': 'Brand',
      name: productBundle?.bundle?.selectedRentalStation?.tenant.name,
      identifier: productBundle?.bundle?.selectedRentalStation?.tenant.key,
    },
    'isVariantOf': {
      '@type': 'ProductGroup',
      name: productBundle?.bundle?.type.title,
      productGroupID: productBundle?.bundle?.type.id,
      offers,
    },
    offers,
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredJSON) }}/>;
};
